import React from "react"

type FormatterContextType = {
  date?: string
  number?: string
  timeZone?: string
}

export const FormatterContext = React.createContext<FormatterContextType>({
  date: "DMY",
  number: "DC",
  timeZone: undefined,
})

export const useFormatterContext = () => React.useContext(FormatterContext)
